export const routeEndpoints = {
  analyticsDashboard: "/analytics",
  analyticsDeviceDetails: "/analytics/device",
  operationsDashboard: "/operations",
  operationsEmulatorDetails: "/operations/emulator",
  operationsCollectorDetails: "/operations/collector",
  vehicleDetails: "/operations/vehicle-details",
};
